import React, { useState, useEffect } from 'react';
import {number, func, bool, array} from 'prop-types';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import {APIS} from '../../../config/apis';
import {ServerRequest} from '../../../utils/apiweb';
import {isNull, isValidNumber} from '../../../utils/validator';
import {OpenObjectURL} from '../../../utils/helpers';
import {useLista} from '../../hooks/useLista';
import {TIPS} from "../../../consts/tips";
import {Accordion} from "../../common";

import { useFormErrors } from '../../hooks/useFormErrors';
import { CheckboxButton, DatePickerCustom, FormError, FormLabel, InputCodigo, InputNumber, InputPercent, Modal, Select, TableCustom } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';

const TipoActoProcesalModal = (props) => {

    //variables
    const entityInit = {
        id: 0,
        idTipoActoProcesal: 0,
        codigoActoProcesal: '',
        descripcion: '',
        plazoDias: 0,
        porcentajeHonorarios: 0,
        fechaBaja: null,
        nivel: 1,
        orden: 1,
        sentencia: false,
        anulacion: false
    };

    //hooks
    const [state, setState] = useState({
        loading: false,
        entity: entityInit,
    });

    const [plantillasDocumentos, setPlantillasDocumentos] = useState([]);

    const mount = () => {

        if (props.id > 0) {
            FindTipoActoProcesal();
            SearchPlantillasDocumentos();
        }

        const unmount = () => {
        }
        return unmount;
    }
    useEffect(mount, []);

    const [formValues, formHandle, , formSet] = useForm({
        codigoActoProcesal: '',
        descripcion: '',
        plazoDias: 0,
        porcentajeHonorarios: 0,
        fechaBaja: null,
        idPlantillaDocumentoDisponible: 0,
        sentencia: false,
        anulacion: false
    });

    const [, getRowLista] = useLista({
        listas: ['TipoPlantillaDocumento'],
        onLoaded: (listas, isSuccess, error) => {
            if (!isSuccess) {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'TipoPlantillaDocumento',
            timeout: 0
        }
    });

    const getDescTipoPlantillaDocumento = (id) => {
        const row = getRowLista('TipoPlantillaDocumento', id);
        return (row) ? row.nombre : '';
    }

    const cellVMR = (data) => <div className='action'>
        <div onClick={(event) => handleClickDocDownload(data.value)} className="link">
            <span className="material-symbols-outlined" title="Descargar">download</span>
        </div>
        {!props.disabled &&
            <div onClick={(event) => handleClickDocRemove(data.value)} className="link">
                <span className="material-symbols-outlined" title="Eliminar">delete</span>
            </div>
        }
    </div>

    const tableColumns = [
        {
            Header: 'Tipo plantilla', Cell: (data) => {
                return getDescTipoPlantillaDocumento(data.value);
            }, accessor: 'idTipoPlantillaDocumento', width: '40%'
        },
        {Header: 'Descripción', accessor: 'descripcion', width: '50%'},
        {
            Header: '',
            Cell: cellVMR,
            id: 'abm',
            accessor: 'id',
            width: '10%',
            disableGlobalFilter: true,
            disableSortBy: true
        }
    ];

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickDocDownload = (id) => {

        const rowForm = plantillasDocumentos.find(x => x.id === id);
        const callbackSuccess = (response) => {
            response.blob()
                .then((buffer) => {
                    OpenObjectURL(rowForm.nombre, buffer);
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                });
        };

        const paramsHeaders = {
            "Content-Type": "application/octet-stream"
        };
        const paramsUrl = `/${rowForm.path}`;
        ServerRequest(
            REQUEST_METHOD.GET,
            paramsHeaders,
            true,
            APIS.URLS.FILE,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }
    const handleClickDocAdd = () => {
        const id = formValues.idPlantillaDocumentoDisponible;
        let list = [...plantillasDocumentos];
        let doc = list.find(f => f.id === id);
        doc.selected = true;
        doc.modified = true;
        formSet({...formValues, idPlantillaDocumentoDisponible: 0});
        setPlantillasDocumentos(list);
    }
    const handleClickDocRemove = (id) => {
        let list = [...plantillasDocumentos];
        let doc = list.find(f => f.id === id);
        doc.selected = false;
        doc.modified = true;
        setPlantillasDocumentos(list);
    }

    const handleClickAceptar = () => {
        if (validate()) {
            if (props.id == 0 || props.addChildren) {
                AddTipoActoProcesal();
            } else {
                ModifyTipoActoProcesal();
            }
        }
        ;
    }
    const handleClickCancelar = () => {
        props.onDismiss();
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }

    // funciones
    function getErrors() {

        const errors = {};

        if (formValues.codigoActoProcesal.length === 0) errors.codigoActoProcesal = VALIDATION_MESSAGE.REQUIRED
        if (formValues.descripcion.length === 0) errors.descripcion = VALIDATION_MESSAGE.REQUIRED

        return errors;
    }

    function FindTipoActoProcesal() {

        setState(prevState => {
            return {...prevState, loading: true};
        });


        const callbackSuccess = (response) => {
            response.json()
                .then((data) => {
                    if (data.fechaBaja) data.fechaBaja = new Date(data.fechaBaja);

                    if (props.addChildren) {
                        setState(prevState => {
                            return {
                                ...prevState,
                                entity: {
                                    idTipoActoProcesal: data.id,
                                    nivel: data.nivel + 1,
                                    orden: data.orden + 1
                                }
                            }
                        });
                    } else {
                        setState(prevState => {
                            return {...prevState, loading: false, entity: data};
                        });
                    }

                    formSet({
                        codigoActoProcesal: (!props.addChildren) ? data.codigoActoProcesal : "",
                        descripcion: (!props.addChildren) ? data.descripcion : "",
                        plazoDias: (!props.addChildren) ? data.plazoDias : 0,
                        porcentajeHonorarios: (!props.addChildren) ? data.porcentajeHonorarios : 0,
                        fechaBaja: (!props.addChildren) ? data.fechaBaja : null,
                        sentencia: (!props.addChildren) ? data.sentencia : false,
                        anulacion: (!props.addChildren) ? data.anulacion : false,
                    });
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                });
        };

        const paramsUrl = `/${props.id}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.TIPO_ACTO_PROCESAL,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function AddTipoActoProcesal() {
        const method = REQUEST_METHOD.POST;
        const paramsUrl = null;
        SaveTipoActoProcesal(method, paramsUrl);
    }

    function ModifyTipoActoProcesal() {
        const method = REQUEST_METHOD.PUT;
        const paramsUrl = `/${props.id}`;
        SaveTipoActoProcesal(method, paramsUrl);
    }

    function SaveTipoActoProcesal(method, paramsUrl) {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
                .then((row) => {
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });

                    if (plantillasDocumentos.filter(f => f.modified).length > 0) {
                        SavePlantillasDocumentos();
                    } else {
                        props.onConfirm(row.id);
                    }

                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                });
        };

        const dataBody = {
            ...state.entity,
            idTipoActoProcesal: state.entity.idTipoActoProcesal,
            codigoActoProcesal: formValues.codigoActoProcesal,
            descripcion: formValues.descripcion,
            plazoDias: formValues.plazoDias,
            porcentajeHonorarios: formValues.porcentajeHonorarios,
            fechaBaja: formValues.fechaBaja,
            nivel: state.entity.nivel,
            orden: state.entity.orden,
            sentencia: formValues.sentencia,
            anulacion: formValues.anulacion
        };

        ServerRequest(
            method,
            null,
            true,
            APIS.URLS.TIPO_ACTO_PROCESAL,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function SearchPlantillasDocumentos() {

        setState(prevState => {
            return {...prevState, loading: true};
        });
        setPlantillasDocumentos([]);

        const callbackSuccess = (response) => {
            response.json()
                .then((data) => {
                    let list = props.list.map(x => {
                        x.selected = (!isNull(data.find(f => f.id === x.id)));
                        x.modified = false;
                        return x;
                    });
                    setPlantillasDocumentos(list);
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                });
        };

        const paramsUrl = `/tipo-acto-procesal/${props.id}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PLANTILLA_DOCUMENTO,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function SavePlantillasDocumentos() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            response.json()
                .then((row) => {
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                    props.onConfirm(row.id);
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setState(prevState => {
                        return {...prevState, loading: false};
                    });
                });
        };

        const dataBody = {
            plantillasDocumentos: plantillasDocumentos.filter(f => f.selected).map(x => x.id)
        };
        const paramsUrl = `/${props.id}/plantilla-documento`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.TIPO_ACTO_PROCESAL,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    return (
        <>

            <Modal
                size="lg"
                title={`Tipo acto procesal: ${(props && props.id > 0) ? state.entity.codigoActoProcesal : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.ENTIDAD_MODAL}
                onEscape={handleClickCancelar}
                body={(
                            <div className="row">

                                <div className="mb-3 col-12 col-md-6 col-xl-3">
                                    <FormLabel htmlFor="codigoActoProcesal" required>Acto procesal</FormLabel>
                                    <input
                                        type="text"
                                        name="codigoActoProcesal"
                                        placeholder=""
                                        className={`form-control ${errorOf('codigoActoProcesal') ? 'is-invalid' : ''}`}
                                        value={formValues.codigoActoProcesal}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                        maxLength={20}
                                    />
                                    <FormError message={errorOf('codigoActoProcesal')} />
                                </div>
                                <div className="mb-3 col-12 col-md-6 col-xl-5">
                                    <FormLabel htmlFor="descripcion" required>Descripción</FormLabel>
                                    <input
                                        name="descripcion"
                                        type="text"
                                        placeholder=""
                                        className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                                        value={formValues.descripcion}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('descripcion')} />
                                </div>
                                <div className="mb-3 col-12 col-md-6 col-xl-2">
                                    <label htmlFor="plazoDias" className="form-label">Plazo días</label>
                                    <InputNumber
                                        name="plazoDias"
                                        placeholder=""
                                        className="form-control"
                                        value={formValues.plazoDias}
                                        precision={0}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                    <FormError />
                                </div>
                                <div className="mb-3 col-12 col-md-6 col-xl-2">
                                    <label htmlFor="porcentajeHonorarios" className="form-label">Honorarios</label>
                                    <InputPercent
                                        name="porcentajeHonorarios"
                                        placeholder=""
                                        className="form-control"
                                        value={formValues.porcentajeHonorarios}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                    <FormError />
                                </div>
                                <div className="mb-3 col-12 col-md-6 col-xl-3">
                                    <label htmlFor="fechaBaja" className="form-label">Baja</label>
                                    <DatePickerCustom
                                        name="fechaBaja"
                                        placeholder=""
                                        className="form-control"
                                        value={formValues.fechaBaja}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                    <FormError />
                                </div>
                                <div className="mb-3 col-12 col-md-6 col-xl-3 align-self-end">
                                    <CheckboxButton
                                        name="sentencia"
                                        label="Es sentencia"
                                        checked={formValues.sentencia}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                </div>
                                <div className="mb-3 col-12 col-md-6 col-xl-3 align-self-end">
                                    <CheckboxButton
                                        name="anulacion"
                                        label="Es anulación"
                                        checked={formValues.anulacion}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                </div>

                                {props.id > 0 &&
                                    <div className="mb-3 col-12">
                                        <Accordion title="Modelos asociados">
                                            <div className='row form-basic'>
                                                {!props.disabled &&
                                                    <>
                                                        <div className="mb-3 col-8">
                                                            <label htmlFor="idPlantillaDocumentoDisponible"
                                                                   className="form-label">Plantillas
                                                                disponibles</label>
                                                            <Select
                                                                name="idPlantillaDocumentoDisponible"
                                                                className="form-control"
                                                                value={formValues.idPlantillaDocumentoDisponible}
                                                                onChange={formHandle}
                                                                emptyOption="Sin selección"
                                                                emptyValue={0}
                                                                options={plantillasDocumentos.filter(f => !f.selected).map(item =>
                                                                    ({value: item.id, label: `${getDescTipoPlantillaDocumento(item.idTipoPlantillaDocumento)} - ${item.descripcion}`})
                                                                )}
                                                            />
                                                        </div>
                                                        <div className="mb-3 col-4 m-top-32">
                                                            {formValues.idPlantillaDocumentoDisponible > 0 &&
                                                                <button className="btn btn-primary float-end"
                                                                        data-dismiss="modal"
                                                                        onClick={(event) => handleClickDocAdd()}>Agregar
                                                                    modelo</button>
                                                            }
                                                        </div>
                                                    </>
                                                }
                                                <div className="mb-3 col-12">
                                                    <TableCustom
                                                        showFilterGlobal={false}
                                                        className={'TableCustomBase'}
                                                        columns={tableColumns}
                                                        data={plantillasDocumentos.filter(f => f.selected)}
                                                    />
                                                </div>
                                            </div>
                                        </Accordion>
                                    </div>
                                }
                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickCancelar()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => handleClickCancelar()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

TipoActoProcesalModal.propTypes = {
    disabled: bool,
    id: number.isRequired,
    addChildren: bool.isRequired,
    list: array.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

TipoActoProcesalModal.defaultProps = {
    disabled: false
};

export default TipoActoProcesalModal;